import { useState, useEffect } from 'react';
import { execSeatableSql } from './seatable.js';
import * as consts from '../consts.js';
import SectionHeader from './sectionheader.js';
import AllImg from './allimg.js';

function TechStack(props) {
    const [data, setData] = useState(null);
    // const [ltrData, setLtrData] = useState(null);
    // const [rtlData, setRtlData] = useState(null);

    useEffect(() => {
        async function fetchData() {
            const sql = `SELECT * FROM \`Tech Stack\` WHERE \`Capability\` = '${props.capability}'`;
            // setLtrData(null);
            // setRtlData(null);

            try {
                const rows = await execSeatableSql(sql);
                setData(rows && rows.results);
                // setLtrData(rows && (rows.results.length > 0) && rows.results[0].Detail.split(','));
                // setRtlData(rows && (rows.results.length > 1) && rows.results[1].Detail.split(','));
            } catch (err) {
                // setError(err);
            }
        }
        fetchData();
    }, [props.capability]);

    return <>
        {(data && (data.length > 0)) ? <>
            <div id="TechStack" className='nav-margin'>
                <SectionHeader capability={props.capability} section="TechStack"/>
            </div>
            {/*
            <div className="techStackSection">
                <div className="Container Fluid">
                    <div className="scrollLeftToRight d-flex align-items-center flex-nowrap gap-5 techStackList">
                        {ltrData && ltrData.map((row) => {
                            return (
                                <div className="stackName">{row}</div>
                            )
                        })}
                    </div>
                    <div className="scrollRightToLeft d-flex align-items-center flex-nowrap gap-5 techStackList">
                        {rtlData && rtlData.map((row) => {
                            return (
                                <div className="stackName">{row}</div>
                            )
                        })}
                    </div>
                </div>
            </div>
            */}
            <div className="tech-stack pb-5 border-bottom border-secondary">
                {data && data.map((row, index) => { return (
                    <div key={index} className="p-3 tech-card flex-lg-row flex-column">
                        <div className="d-flex">
                            <div className="mb-auto me-3" style={{minWidth: "10px", minHeight: "30px", backgroundColor: `${consts.colorPalette[index%9]}`}}></div>
                            <div className="me-lg-3 my-3 w-lg-25 w-100 d-flex justify-content-center align-items-center">
                                <AllImg className="card-icon" src={row.fnMediaLink} alt={row.Desc} />
                            </div>
                        </div>
                        <div className="w-lg-75 w-100">
                            <h4 className="my-3">{row.Heading}</h4>
                            {row.Detail.split(/\r?\n/).filter(e => e.trim() !== '').map((lineItem, lidx) => 
                                <div className="mb-2 pb-1">{lineItem}</div>
                            )}
                        </div>
                    </div>
                )})}
            </div>
        </>: ''}
    </>
}

export default TechStack;